import "./invite.less";
import { useState, useRef, useCallback, useEffect } from "react";
import { Toast } from "react-vant";
import { getUrlParams } from "utils/tools";
import { newRegister, sendVerificationCode, visit } from "@/api/register";

const topImg = require("@/assets/images/new-invite/top.png");
const btnImg = require("@/assets/images/new-invite/btn.png");

export default function SalesInvite() {
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [agreed, setAgreed] = useState(false);
  const [codeText, setCodeText] = useState("发送验证码");
  const countDownRef = useRef(null);

  useEffect(() => {
    const urlParams = getUrlParams();
    const params = {};
    if (urlParams.second_source) {
      params.second_source = urlParams.second_source;
    }
    visit(params);
  }, []);

  const handleSendCode = useCallback(async () => {
    if (countDownRef.current) return;
    if (!phone) return Toast.info("请输入手机号码");
    if (!/^\d{11}$/.test(phone)) return Toast.info("请输入正确的手机号码");

    const loadingToast = Toast.loading({
      message: "正在发送验证码...",
      forbidClick: true,
      duration: 0
    });
    const result = await sendVerificationCode({ phone_number: phone });
    loadingToast.clear();

    if (result && result.status === true) {
      let time = 60;
      setCodeText(`再次发送(${time}s)`);
      countDownRef.current = setInterval(() => {
        --time;
        if (time > 0) {
          setCodeText(`再次发送(${time}s)`);
        } else {
          clearInterval(countDownRef.current);
          countDownRef.current = null;
          setCodeText("发送验证码");
        }
      }, 1000);
    } else {
      Toast.info(result?.message ?? "发送失败");
    }
  }, [phone]);

  const handleSubmit = useCallback(async () => {
    if (!phone) return Toast.info("请输入手机号");
    if (!/^\d{11}$/.test(phone)) return Toast.info("请输入正确的手机号码");
    if (!code) return Toast.info("请输入验证码");
    if (!agreed) return Toast.info("请勾选同意协议");

    const urlParams = getUrlParams();
    const params = {
      phone_number: phone,
      verification_code: code,
      source: urlParams.source,
      second_source: urlParams.second_source,
    };
    const res = await newRegister(params);
    if (res?.code === 200 && res?.data?.link) {
      Toast.info(res?.message ?? "注册成功");
      setTimeout(() => {
        window.location.href = res.data.link;
      }, 2000);
    } else {
      Toast.info(res?.message ?? "未知错误");
    }
  }, [phone, code, agreed]);

  return (
    <div className="sales-invite-page">
      <div className="sales-invite-inner">
        <div className="top-banner">
          <img src={topImg} alt="banner" />
        </div>

        <div className="form-card">
          <div className="form-item">
            <input
              className="form-input"
              type="tel"
              placeholder="手机号"
              maxLength={11}
              value={phone}
              onChange={e => setPhone(e.target.value)}
            />
          </div>

          <div className="form-item code-row">
            <input
              className="form-input code-input"
              type="text"
              placeholder="验证码"
              maxLength={6}
              value={code}
              onChange={e => setCode(e.target.value)}
            />
            <button
              className={`send-code-btn${countDownRef.current ? " disabled" : ""}`}
              onClick={handleSendCode}
            >
              {codeText}
            </button>
          </div>

          <div className="agreement-row">
            <span
              className={`custom-checkbox${agreed ? " checked" : ""}`}
              onClick={() => setAgreed(v => !v)}
            >
              {agreed && <span className="checkmark">✓</span>}
            </span>
            <span className="agreement-text">
              同意
              <a
                className="link"
                href="https://cdn06.myaitalk.vip/privacy/en/v2/reading-course-service-agreement.html"
                target="_blank"
                rel="noreferrer"
              >
                《课程服务协议》
              </a>
              与
              <a
                className="link"
                href="https://cdn03.myaitalk.vip/utalkrc/privacy/en/pocketlinghang-reading-privacy-policy-v4.html"
                target="_blank"
                rel="noreferrer"
              >
                《隐私政策》
              </a>
            </span>
          </div>

          <div className="submit-row">
            <button className="submit-btn" onClick={handleSubmit}>
              <img src={btnImg} alt="立即体验" />
            </button>
          </div>

          <p className="footer-tip">前100名注册用户享优惠！</p>
        </div>
      </div>
    </div>
  );
}
